<template>
  <div class="create">
    <div class="f-14 f-w pd-15">创建您感兴趣的话题</div>
    <van-grid :border="false" :column-num="3">
      <van-grid-item v-for="item in list" :key="'list_' + item.id" @click="binGrid(item.id)">
       <div class="topicimg" :style="'background-image:url('+item.pic_url+')'">
        <div class="f-12 c-white mt-30">{{item.name}}
          <div v-if="params.category_id==item.id">
            <van-icon name="success" color="#fff" size="12" />
          </div>
        </div>
      </div>
    </van-grid-item>
  </van-grid>
  <van-field v-model="params.name" class="f-12" placeholder="#请输入话题内容#" />
  <div class="btn-bott">
    <van-button color="#605C6B" size="large" @click="SaveTopic()">创建话题</van-button>
  </div>
</div>
</template>
<script>
  import post from '../../../api/lexus/release';
  import common from '../../../api/common';
  import { Grid, GridItem,Field,Button,Icon } from 'vant';
  import { mapState } from 'vuex';
  export default {
    data () {
      return {
        brand_id:1,
        list:[],
        params:{
          brand_id:1,
          category_id:'',
          name:'',
          source:''
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      this.params.source=this.source
      this.getCategories()
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      var params={
        event_code: '创建话题',
        event_id:'',
        title: '',
        value: '',
        path: '/Lexus/Release/CreateTopic.vue',
        user_id: this.user_id ? this.user_id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    activated () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      this.getCategories()
    },
    methods: {
      getCategories(){
        post.getCategories(this.brand_id).then(res => {
          if(res.data.state == 1) {
            this.list.push.apply(this.list, res.data.data)
            this.params.category_id=this.list[0].id
          }
        })
      },
      binGrid(id){
        this.params.category_id=id
      },
      SaveTopic(){
        var name=this.params.name
        this.params.name= name.replace(/#/g, "");
        post.SaveTopic(this.params).then(res => {
          if(res.data.state == 1) {
            this.$toast.success('创建成功')
            setTimeout(() => {

              var params={
                idlist:[res.data.data.id],
                namelist:[this.params.name],
                type:1
              }
              this.$appService.choiseType(params)
            }, 1000);
          }
        })
      }
    },
    components: {
      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
      [Field.name]:Field,
      [Button.name]:Button,
      [Icon.name]:Icon
    }
  }
</script>
<style lang="scss">
.create{
 .pd-15{
  padding: 10px 20px;
}
.van-grid{
  padding:0 15px;
}
.van-grid-item__content{
  padding: 5px 5px;
  img{
    width: 100%;
  }
}
.van-cell{
  padding: 0 20px;
  margin-top: 30px;
  border-bottom: 1px solid #f8f8f8;
}
.btn-bott{
  position: fixed;
  bottom: 10px;
  width: 100%;
  text-align: center;
}
.van-button{
  width: 90%;
  height: 40px;
  line-height: 2;
  font-size: 12px;
}
.van-icon{
  color: rgb(255, 255, 255);
  background: rgb(123, 178, 103);
  border-radius: 30px;
  padding: 2px 6px;
  margin-top: 3px;
}
.topicimg{
  width: 100%;
  height: 108px;
  text-align: center;
  background-size:cover;
}
.mt-30{
  margin-top: 45%;
  margin-bottom: 2px;
}
}
</style>
